import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import ShieldIcon from '@mui/icons-material/Shield';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import SpaIcon from '@mui/icons-material/Spa';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import HeroBuildingImage from '../../../src/Images/BackgroundImage.png';
import './Login.css';

const FEATURES = [
  { icon: <MonitorHeartIcon fontSize="small" />, label: 'Real-time Monitoring' },
  { icon: <AutoAwesomeIcon fontSize="small" />, label: 'AI-Powered Analytics' },
  { icon: <EnergySavingsLeafIcon fontSize="small" />, label: 'Resource Efficiency' },
  { icon: <ShieldIcon fontSize="small" />, label: 'Compliance & Safety' },
];

const STATS = [
  { icon: <ApartmentIcon fontSize="small" />, value: '500+', label: 'Buildings' },
  { icon: <ShowChartIcon fontSize="small" />, value: '10M+', label: 'Intelligence points/day' },
  { icon: <SpaIcon fontSize="small" />, value: '30%+', label: 'Avg. Resource Savings' },
  { icon: <AccessTimeIcon fontSize="small" />, value: '24/7', label: 'System Uptime' },
];

function BrandMark({ size = 34 }) {
  return (
    <div className="gv-brand-mark" style={{ width: size, height: size }}>
      <HomeWorkIcon style={{ fontSize: size * 0.58 }} />
      <span className="gv-brand-dot" />
    </div>
  );
}

export default function AuthHero() {
  return (
    <div className="gv-login-hero">
      <div className="gv-login-hero-top">
        <BrandMark size={38} />
        <div>
          <div className="gv-login-hero-brand-title">GREENVIRONMENT</div>
          <div className="gv-login-hero-brand-sub">AI DASHBOARD</div>
        </div>
      </div>

      <div className="gv-login-hero-headline">
        Intelligence that drives <span className="accent">sustainability</span>
      </div>
      <div className="gv-login-hero-sub">
        AI-powered insights for smarter buildings, efficient operations and a greener tomorrow.
      </div>

      <div className="gv-login-hero-features">
        {FEATURES.map((f) => (
          <div className="gv-login-hero-feature" key={f.label}>
            <div className="gv-login-hero-feature-ico">{f.icon}</div>
            <div className="gv-login-hero-feature-label">{f.label}</div>
          </div>
        ))}
      </div>

      <img src={HeroBuildingImage} alt="" className="gv-login-hero-building" aria-hidden="true" />

      <div className="gv-login-hero-spacer" />

      <div className="gv-login-hero-stats">
        {STATS.map((s) => (
          <div className="gv-login-hero-stat" key={s.label}>
            <div className="gv-login-hero-stat-ico">{s.icon}</div>
            <div>
              <div className="gv-login-hero-stat-value">{s.value}</div>
              <div className="gv-login-hero-stat-label">{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="gv-login-hero-footer">
        <VerifiedUserIcon fontSize="small" />
        <span>Enterprise-grade security. Your data is safe with us. ISO 27001 aligned &middot; Secure &amp; Encrypted</span>
      </div>
    </div>
  );
}
